/* Copyright (c) 2020-present CloudIO Inc */

import { WSSuccessResponse } from '@cloudio-saas/datasource-types';
import { action, atom } from '@cloudio-saas/statex';
import type { SQLType } from './SQL';

export const recentSQLsAtom = atom<SQLType[]>({
  path: ['runtime', 'dev', 'recent_sqls'],
  defaultValue: [],
});

export const processResponseAction = action(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ set, get }, response: WSSuccessResponse<any>): void => {
    const { uid, timestamp, data } = response;
    const aliases = Object.keys(data ?? {});
    aliases.forEach((alias, index) => {
      const {
        sql,
        queryElapsed,
        params,
        connectionElapsed,
        rowsFetched,
        pageId,
      } = data[alias] as SQLType;
      if (sql || rowsFetched !== undefined) {
        set(recentSQLsAtom, (list) => [
          ...list,
          {
            sql: sql ?? 'NO_SQL',
            queryElapsed,
            rowsFetched,
            params: params ?? [],
            connectionElapsed,
            timestamp,
            uid: aliases.length > 1 ? `${uid}-${index}` : uid,
            alias,
            endTime: new Date().getTime(),
            pageId,
          },
        ]);
      }
    });
  },
);
